import defaultApi from './defaultApi';
import store from '@/store';
import { sendRequest } from './common/commonApi';
const agentApi = {
  agent: {
    prefix: process.env.VUE_APP_PROXY + process.env.VUE_APP_PUBLIC_PATH + '/cloudmonitorings/agent',
    SWAGGER: '/v2/api-docs?group=API-v1.0.0',
    API_INFO: {},
    SAMPLE: {},

    // 에이전트 상품 유형 조회
    getProductSubTypes() {
      if (store.state.agentProductTypes != null && store.state.agentProductTypes.length > 0) {
        return Promise.resolve(store.state.agentProductTypes);
      }

      return new Promise((resolve) => {
        let param = {};
        this.get('/v1/console/agents/products-types', param).then((data) => {
          let _codes = [];
          if (data) {
            for (let i = 0; i < data.contents.length; i++) {
              let _row = data.contents[i];
              _codes.push({ text: _row.productTypeName, value: _row.productTypeCode, ..._row });
            }
          }
          store.commit('setAgentProductTypes', _codes);
          resolve(_codes);
        });
      });
    },

    // 에이전트 목록 조회
    getAgents(params, loadingbar) {
      return new Promise((resolve, reject) => {
        this.post('/v1/console/agents', params, loadingbar, false, {
          headers: { 'X-ResourceType': params.productTypeCode }
        })
          .then((data) => {
            if (Object.keys(data).length > 0) {
              return resolve(data);
            }
          })
          .catch((error) => reject(error));
      });
    },

    // 에이전트 유형 조회
    getAgentType(params, productTypeCode) {
      return sendRequest(
        this.get.bind(this),
        '/v1/console/agent-types',
        {
          params,
          productTypeCode
        },
        true
      );
    },

    // 에이전트 버전 조회
    getAgentVersion(params, productTypeCode) {
      return sendRequest(
        this.get.bind(this),
        '/v1/console/agent-versions',
        {
          params,
          productTypeCode
        },
        true
      );
    },

    // 에이전트 설치/삭제/업데이트/시작/중지
    agentAction(params, productTypeCode) {
      return new Promise((resolve, reject) => {
        this.post(
          `/v1/console/agents/${params.actionName}`,
          { agentSqList: params.agentSqList },
          true,
          false,
          { headers: { 'X-ResourceType': productTypeCode, 'X-Request-Id': '1' } }
        )
          .then((data) => {
            if (Object.keys(data).length > 0) {
              return resolve(data);
            }
          })
          .catch((error) => reject(error));
      });
    },

    // 수집 로그 사용여부 설정
    changeAgentState(params, agentSeq, productTypeCode, handledAuthError = false) {
      return new Promise((resolve, reject) => {
        this.put(
          `/v1/console/agents/${agentSeq}/logs`,
          params,
          true,
          false,
          {
            headers: { 'X-ResourceType': productTypeCode }
          },
          false,
          [],
          { handledAuthError }
        )
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },

    // 수집 로그 추가
    addAgentLog(params, agentSeq, productTypeCode, handledAuthError = false) {
      return new Promise((resolve, reject) => {
        this.post(
          `/v1/console/agents/${agentSeq}/logs`,
          params,
          true,
          false,
          {
            headers: { 'X-ResourceType': productTypeCode }
          },
          false,
          [],
          { handledAuthError }
        )
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },

    // 수집 로그 삭제
    deleteAgentLog(params, agentSeq, productTypeCode, handledAuthError = false) {
      return new Promise((resolve, reject) => {
        this.delete(
          `/v1/console/agents/${agentSeq}/logs`,
          {},
          params,
          true,
          false,
          {
            headers: { 'X-ResourceType': productTypeCode }
          },
          false,
          [],
          { handledAuthError }
        )
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },

    // 에이전트 변경 이력 조회
    getAgentHistory(params, subUrl, productTypeCode, loadingbar) {
      return new Promise((resolve, reject) => {
        this.get(`/v1/console/agents/histories?${subUrl}`, params, loadingbar, false, {
          headers: { 'X-ResourceType': productTypeCode }
        })
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },

    getManualAgent(resourceId, agentType) {
      return new Promise((resolve, reject) => {
        this.get(`/v1/manual/agents/${resourceId}/prepare/${agentType}`, true, true)
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },

    checkAgentTab(resourceId) {
      return new Promise((resolve, reject) => {
        this.get(`/v1/manual/agents/${resourceId}/prepare/check`, true, true)
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    }
  }
};
agentApi.agent = Object.assign(agentApi.agent, defaultApi);
export default agentApi;
